export default __webpack_public_path__ + "static/media/tour-4.54a5dbc7.jpeg";